module.exports = __webpack_public_path__ + "static/media/care1.e0b86c45.jpg";